import { BonjoroService } from '~/types/plans';

export function useServices() {
  const services = window.Bonjoro.user.services;
  return {
    canAccessTestimonials: services.includes(BonjoroService.Testimonials),
    canAccessVideoMessaging: services.includes(BonjoroService.VideoMessaging),
    services,
  };
}
